import * as jsxRuntime from "/home/runner/work/webadmin-v2/webadmin-v2/frontend/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment